module.exports = __webpack_public_path__ + "static/media/DaysOffTemplate.0c0d0e30.csv";